import React from 'react';
import { Youtube } from 'lucide-react';
import { Panel, BarRow, Big } from './parts';

export const VideoFunnel = ({ v }) => (
  <Panel title="Landing video" testId="growth-video">
    <div className="flex items-end justify-between gap-4 mb-5">
      <Big label="Landing page visitors" value={v.landing_visitors} testId="growth-landing-visitors" />
      <div className="text-right">
        <div className="text-xs text-slate-500 flex items-center justify-end gap-1"><Youtube className="w-3.5 h-3.5 text-[#FF0000]" />Channel subscribe clicks</div>
        <div className="text-2xl font-black tabular-nums text-slate-900" data-testid="growth-channel-clicks">{v.channel_clicks}</div>
      </div>
    </div>
    <div className="space-y-3">
      {['25', '50', '75', '100'].map((m) => (
        <BarRow key={m} label={m === '100' ? 'Watched to the end' : `Watched ${m}%`} count={v.reached[m]} pct={v.reached_pct[m]} testId={`growth-watched-${m}`} />
      ))}
    </div>
    <p className="text-xs text-slate-400 mt-4">Counted once per visitor. The video starts playing muted, so these include muted viewing.</p>
  </Panel>
);
